angular.module('zc.zenclerkS')
  .component('zcsCampaignEditStepSegment', {
    templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_segment.html',
    require: {
      campaignEdit: '^zcsCampaignEdit'
    },
    controller: ZcsSegmentCampaignProposalsController,
  });

ZcsSegmentCampaignProposalsController.$inject = ['$state', 'ZcsProject', 'ZcsEstimator', 'ZcsSegment', 'Devise', 'ZcsOemService'];
function ZcsSegmentCampaignProposalsController($state, ZcsProject, ZcsEstimator, ZcsSegment, Devise, ZcsOemService) {
  const vm = this;

  vm.ZcsOemService = ZcsOemService;

  vm.$onInit = () => {
    vm.campaign = vm.campaignEdit.campaign;
    vm.project = vm.campaignEdit.project;

    // variables
    vm.segments = [];
    vm.estimatedCv = ZcsSegment.estimatedCv;
    // states
    if(vm.campaign.segment_id && vm.campaign.segment) {
      vm.selectedSegmentName = vm.campaign.segment.name;
    }

    vm.isActive = isActive;
    vm.isAllowedToSelect = isAllowedToSelect;
    vm.isCurrentSelected = isCurrentSelected;

    // actions
    vm.toggleSegment = toggleSegment;

    // for ability to select detailed sub cv segments
    vm.baseCvSegment = 'zcs_segment_cv_users';
    vm.subCvSegments = ['zcs_segment_one_cv', 'zcs_segment_loyal'];
    vm.allCvSegments = vm.subCvSegments.concat(vm.baseCvSegment);
    vm.allCvSegmentProposals = [];
    vm.selectedCvSegmentProposal = null;

    ZcsSegment.getProposals(vm.project)
      .then(proposals => {
        vm.allCvSegmentProposals = _.filter(proposals, proposal => _.includes(vm.allCvSegments, proposal.name));
        if(vm.campaign.segment && _.includes(vm.allCvSegments, vm.campaign.segment.name)) {
          vm.selectedCvSegmentProposal = _.find(vm.allCvSegmentProposals, proposal => proposal.name === vm.campaign.segment.name);
        } else {
          vm.selectedCvSegmentProposal = _.find(vm.allCvSegmentProposals, proposal => proposal.name === vm.baseCvSegment);
        }
        vm.proposals = _.chain(proposals)
          .reject(proposal => _.includes(vm.subCvSegments, proposal.name))
          .sortBy(proposal => -proposal.stats.estimatedMonthlyCouponRevenue)
          .value();
        if(!vm.campaign.segment_id) {
          vm.selectedSegmentName = vm.proposals[0].name;
          vm.campaign.segment_id = vm.proposals[0].segment_id;
          vm.campaign.segment = vm.proposals[0].segment;
        }
      });
  };

  function isActive() {
    return (vm.campaign.status !== 'incomplete' && moment().isAfter(moment(vm.campaign.start_at)));
  }

  function isAllowedToSelect(segment) {
    const changingAllowedSegments = ['zcs_segment_all', 'zcs_segment_new', 'zcs_segment_cv_users', 'zcs_segment_one_cv', 'zcs_segment_loyal'];

    if(!isActive()) {
      return true;
    }

    if(vm.campaign.segment && _.includes(changingAllowedSegments, vm.campaign.segment.name)) {
      return segment.name !== 'zcs_segment_mail_only';
    } else if(vm.campaign.segment && vm.campaign.segment.name === 'zcs_segment_mail_only') {
      return segment.name === 'zcs_segment_mail_only';
    }
    return false;
  }

  function isCurrentSelected(segment) {
    if(_.includes(vm.subCvSegments, vm.selectedSegmentName)) {
      return segment.name === vm.baseCvSegment;
    }
    return segment.name === vm.selectedSegmentName;
  }

  function toggleSegment(segmentProposal) {
    if(isAllowedToSelect(segmentProposal)) {
      if(segmentProposal.name === vm.baseCvSegment) {
        segmentProposal = vm.selectedCvSegmentProposal;
      }

      vm.selectedSegmentName = segmentProposal.name;
      vm.campaign.segment_id = segmentProposal.segment_id;
      vm.campaign.segment = segmentProposal.segment;
    }
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/campaign_edit_step_segment.js